export const ResiPermissions = {
    VIEW_GUESTS: 'VIEW_GUESTS',
    INVITE_GUESTS: 'INVITE_GUESTS',
    MANAGE_ACCESS_KEY: 'MANAGE_ACCESS_KEY',
    MANAGE_VISITORS: 'MANAGE_VISITORS',
    MANAGE_OTC: 'MANAGE_OTC',
    VIEW_OCCUPANTS: 'VIEW_OCCUPANTS',
    INVITE_OCCUPANTS: 'INVITE_OCCUPANTS',
    VIEW_VEHICLES: 'VIEW_VEHICLES',
    MANAGE_VEHICLES: 'MANAGE_VEHICLES',
    REQUIRE_PHOTO_ID_BYPASS: 'REQUIRE_PHOTO_ID_BYPASS',
    MANAGE_RENTALS: 'MANAGE_RENTALS'
};
